var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransmissionIcon = function SvgTransmissionIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EEEEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6371 39.6505C65.0901 43.0998 65.3158 46.5507 65.3158 50C65.3158 53.4493 65.0901 56.9002 64.6371 60.3495C64.2109 63.5832 61.4556 66 58.1949 66H42.3533C39.2105 66 36.5175 63.7499 35.96 60.656C35.32 57.104 35 53.552 35 50C35 46.4463 35.32 42.896 35.96 39.344C36.5175 36.2501 39.2105 34 42.3533 34H58.1949C61.4556 34 64.2109 36.4168 64.6371 39.6505Z",
    fill: "#9A9CCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6371 39.6505C65.0901 43.0998 65.3158 46.5507 65.3158 50C65.3158 53.4493 65.0901 56.9002 64.6371 60.3495C64.2109 63.5832 61.4556 66 58.1949 66H42.3533C39.2105 66 36.5175 63.7499 35.96 60.656C35.32 57.104 35 53.552 35 50C35 46.4463 35.32 42.896 35.96 39.344C36.5175 36.2501 39.2105 34 42.3533 34H58.1949C61.4556 34 64.2109 36.4168 64.6371 39.6505Z",
    fill: "#575BAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.397,
    d: "M56.1133 50.2712H44.2025",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1133 43.7634H44.2025",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1579 56.7789H44.2025",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransmissionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "transmission-icon.4c93b38a7d87e0e4deec316d9423ce7a.svg";